import React from "react";
import { Result } from "antd";
import { ClockCircleOutlined } from "@ant-design/icons";

export const RegistroEspecialLiveViews = () => {
	return (
		<div
			style={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				minHeight: "60vh",
				padding: "20px",
			}}
		>
			<Result
				icon={
					<ClockCircleOutlined
						style={{ color: "#ff8034", fontSize: "64px" }}
					/>
				}
				title="Promoção Encerrada"
				subTitle="Esta promoção especial já foi encerrada e não está mais disponível. Fique de olho nas nossas próximas ofertas!"
				style={{
					maxWidth: "500px",
					textAlign: "center",
				}}
			/>
		</div>
	);
};

export default RegistroEspecialLiveViews;
